import React from 'react';
import Grid from '@mui/material/Grid';
import PieChart from '../../charts/PieChart';

const PieChartWrapperComponent = (props) => {

    const { loading, data, centerTitle, centerSubTitle, title, gotoPath, arrayIndex} = props;

    return (
        <div>
            <PieChart
                data={data}
                loading={loading}
                centerTitle={centerTitle}
                centerSubTitle={centerSubTitle}
                title={title}
                gotoPath={gotoPath}
                arrayIndex={arrayIndex}
            />
        </div>
    )
}

export default PieChartWrapperComponent